module.exports = __webpack_public_path__ + "img/15ac9f79-e16d-4d97-b7e5-07834ed4a66a.1d49b22c.jpg";